export enum BlockType {
  START = 'start',
  APPOINTMENT = 'appointment',
  // SUPPORT = 'support',
  COMPLAINT = 'complaint',
  TRANSFER = 'transfer',
  SEND_MESSAGE = 'send_message',
  FILTER = 'filter',
  CUSTOM = 'custom',
}

export interface NodeType {
  id: string;
  type: BlockType;
  position: { x: number; y: number };
  context?: string;
  parentId?: string | null;
  children?: any[];
}

export interface EdgeType {
  id: string;
  source: string;
  target: string;
} 